import React, { useEffect } from 'react';
import { ReCaptcha, loadReCaptcha , } from 'react-recaptcha-v3'
import { useDispatch, useSelector } from 'react-redux';
import { recaptchaDataActions } from '../../redux/recaptcha';

const Recaptcha=React.forwardRef(({ actionName,verifyRecaptcha },ref)=> {
    //const [recaptchaToken,setRecaptchaToken]=useState<string | null>(null);
    //const ref=useRef<ReCaptcha>();
    const siteKey=process.env.REACT_APP_RECAPTHCA_SITE_KEY;
    const dispatch= useDispatch();
    const isRecaptchaLoaded= useSelector(state=> { return state.recaptchaData?.isRecaptchaLoaded})
    useEffect(() => {
        if(!isRecaptchaLoaded){
            loadReCaptcha(siteKey || "");
            dispatch(recaptchaDataActions.setRecaptchaLoaded(null));
        }
        //else{
            document.getElementsByClassName("grecaptcha-badge")[0]?.setAttribute("style",` ${document.getElementsByClassName("grecaptcha-badge")[0]?.getAttribute("style")?.replace(/(?<=visibility:)(.*?)(?=;)/,"unset")}`);
       // }
        return ()=>{
           
                let recaptchaStyle= document.getElementsByClassName("grecaptcha-badge")[0]?.getAttribute("style");
                 
                    if(recaptchaStyle?.includes("visibility"))
                    recaptchaStyle=recaptchaStyle.replace(/(?<=visibility:)(.*?)(?=;)/,"hidden")//find the value of visibilty and replace with hidden
                    else
                    recaptchaStyle+="visibility:hidden;"
                
                document.getElementsByClassName("grecaptcha-badge")[0]?.setAttribute("style",`${recaptchaStyle}`);
           
        }
    }, [])
    return (<ReCaptcha
        ref={ref}
        sitekey={siteKey}
        action={actionName}
        verifyCallback={verifyRecaptcha}/>)

})

export default Recaptcha;
